namespace Nobox.Membership {
    export interface SignUpRequest extends Serenity.ServiceRequest {
        DisplayName?: string;
        Email?: string;
        ConfirmEmail?: string;
        Password?: string;
        ConfirmPassword?: string;
        MobilePhoneNumber?: string;
        Recaptcha?: string;
        CtryId?: number;
        StatesId?: number;
        CityId?: number;
        Opt?: number;
        InvCd?: string;
        TnNm?: string;
        TnIdtry?: number;
        TnSize?: string;
        TnSizeNm?: string;
        TnIdtryNm?: string;
    }
}
